import {useState} from 'react';
import Loading from "../../../generic/Loading";
import Definition from "../../components/Event/Definition";
import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";
import {EventLabel, InfoLabel, SettingsLabel} from "../../../../config/Config";
import UseBlurHandler from "../../hooks/UseBlurHandler";
import Alert from "../../../alert/Alert";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import Field from "../../../form/Field";

const Event = (props) => {
    const {currentNode, onBlur, onChange} = props
    const [loading, setLoading] = useState(false)
    const [definition, setDefinition] = useState(Definition)

    /**
     * Todo: hay que modificar la descripción del componente
     * @type {{docs: {path: string, message: string}, className: string, message: string}}
     */
    const Information = {
        className: 'alert-primary',
        message: `Through this component you can send SMS Rich messages. `,
        docs: {
            message: 'For more information, please ',
            path: '/docs/journeys/sms/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        name: 'info[title]',
        type: 'text',
        label: 'Title',
        wrapper: 'form-group',
        placeholder: 'Type an descriptive title',
        value: UseGetterNodeValue(currentNode, 'info', 'title', EventLabel),
        onBlur: (value) => {
            UseBlurHandler(currentNode, 'info', 'title', value, onBlur)
        }
    }


    const Description = {
        name: 'info[description]',
        type: 'textarea',
        label: 'Description',
        wrapper: 'form-group',
        className: 'form-control',
        placeholder: 'Type a short description',
        value: UseGetterNodeValue(currentNode, 'info', 'description', ''),
        onBlur: (value) => {
            UseBlurHandler(currentNode, 'info', 'description', value, onBlur)
        }
    }

    return (
        <div>
            {loading && <Loading />}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        Pending....
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Event;